// its middlewear to handle reducer call to update a state

import { postData } from "../../../backend/api";

const fetchLogin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USER_LOGIN_LOADING",
    });
    postData(data, "user/validate")
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "FETCH_USER_LOGIN_SUCCESS",
            payload: response.data,
          });
          let currentMenu = response.data.menu[0];
          dispatch({
            type: "MENU_STATUS",
            payload: false,
          });
          dispatch({
            type: "SELECTED_MENU",
            payload: currentMenu,
          });
          dispatch({
            type: "CURRENT_MENU",
            payload: currentMenu.label,
          });
        } else {
          dispatch({
            type: "FETCH_USER_LOGIN_ERROR",
            payload: "validationFailed",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_USER_LOGIN_ERROR",
          payload: "validationFailed",
        });
      });
  };
};
const clearLogin = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_USER_LOGIN",
    });
  };
};
const clearLoginSession = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_USER_LOGIN_SESSION",
    });
  };
};
const udpateLogin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USER_LOGIN_SUCCESS",
      payload: data,
    });
  };
};
export { fetchLogin, clearLogin, clearLoginSession, udpateLogin };
